var exports = {
  "z": "x31de4314--231f03--root",
  "U": "x31de4314--231f03--value",
};

module.exports = exports;
